'use client';

import { c as _c } from "react/compiler-runtime";
import { useLocale, useTranslations } from 'next-intl';
import { Button, Heading } from 'ui';
import { useCurrencyContext } from '~/contexts/Currencies';
import { getPathname } from '~/i18n/navigation';
export default function ReferralCard() {
  const $ = _c(2);
  const isReferEnabled = process.env.NEXT_PUBLIC_FF_REFER_ENABLED === "true";
  if (!isReferEnabled) {
    let t0;
    if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
      t0 = <LegacyReferralCard />;
      $[0] = t0;
    } else {
      t0 = $[0];
    }
    return t0;
  }
  let t0;
  if ($[1] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = <ActiveReferralCard />;
    $[1] = t0;
  } else {
    t0 = $[1];
  }
  return t0;
}
function ActiveReferralCard() {
  const $ = _c(19);
  const t = useTranslations("account");
  const locale = useLocale();
  let t0;
  if ($[0] !== t) {
    t0 = t("referral_heading");
    $[0] = t;
    $[1] = t0;
  } else {
    t0 = $[1];
  }
  let t1;
  if ($[2] !== t0) {
    t1 = <Heading as="h3" variant="h6">{t0}</Heading>;
    $[2] = t0;
    $[3] = t1;
  } else {
    t1 = $[3];
  }
  let t2;
  if ($[4] !== t) {
    t2 = t("referral_body");
    $[4] = t;
    $[5] = t2;
  } else {
    t2 = $[5];
  }
  let t3;
  if ($[6] !== t2) {
    t3 = <p>{t2}</p>;
    $[6] = t2;
    $[7] = t3;
  } else {
    t3 = $[7];
  }
  let t4;
  if ($[8] !== locale) {
    t4 = getPathname({
      href: "/account/refer",
      locale
    });
    $[8] = locale;
    $[9] = t4;
  } else {
    t4 = $[9];
  }
  let t5;
  if ($[10] !== t) {
    t5 = t("referral_cta");
    $[10] = t;
    $[11] = t5;
  } else {
    t5 = $[11];
  }
  let t6;
  if ($[12] !== t4 || $[13] !== t5) {
    t6 = <Button href={t4} size="small" is="a">{t5}</Button>;
    $[12] = t4;
    $[13] = t5;
    $[14] = t6;
  } else {
    t6 = $[14];
  }
  let t7;
  if ($[15] !== t1 || $[16] !== t3 || $[17] !== t6) {
    t7 = <div className="p-4 space-y-3 border rounded-lg bg-primary-100">{t1}{t3}{t6}</div>;
    $[15] = t1;
    $[16] = t3;
    $[17] = t6;
    $[18] = t7;
  } else {
    t7 = $[18];
  }
  return t7;
}
function LegacyReferralCard() {
  const $ = _c(19);
  const t = useTranslations("account");
  const {
    convertPriceInGBP
  } = useCurrencyContext();
  let t0;
  if ($[0] !== convertPriceInGBP || $[1] !== t) {
    t0 = t("referral_heading_legacy", {
      amount: convertPriceInGBP(50)
    });
    $[0] = convertPriceInGBP;
    $[1] = t;
    $[2] = t0;
  } else {
    t0 = $[2];
  }
  let t1;
  if ($[3] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = <span aria-hidden="true">🎁</span>;
    $[3] = t1;
  } else {
    t1 = $[3];
  }
  let t2;
  if ($[4] !== t0) {
    t2 = <Heading as="h3" variant="h6">{t0} {t1}</Heading>;
    $[4] = t0;
    $[5] = t2;
  } else {
    t2 = $[5];
  }
  let t3;
  if ($[6] !== convertPriceInGBP || $[7] !== t) {
    t3 = t("referral_body_legacy", {
      amount: convertPriceInGBP(50)
    });
    $[6] = convertPriceInGBP;
    $[7] = t;
    $[8] = t3;
  } else {
    t3 = $[8];
  }
  let t4;
  if ($[9] !== t3) {
    t4 = <p>{t3}</p>;
    $[9] = t3;
    $[10] = t4;
  } else {
    t4 = $[10];
  }
  let t5;
  if ($[11] !== t) {
    t5 = t("referral_cta");
    $[11] = t;
    $[12] = t5;
  } else {
    t5 = $[12];
  }
  let t6;
  if ($[13] !== t5) {
    t6 = <Button href="https://www.byway.travel/about/refer" size="small" is="a" target="_blank">{t5}</Button>;
    $[13] = t5;
    $[14] = t6;
  } else {
    t6 = $[14];
  }
  let t7;
  if ($[15] !== t2 || $[16] !== t4 || $[17] !== t6) {
    t7 = <div className="p-4 space-y-3 border rounded-lg bg-primary-100">{t2}{t4}{t6}</div>;
    $[15] = t2;
    $[16] = t4;
    $[17] = t6;
    $[18] = t7;
  } else {
    t7 = $[18];
  }
  return t7;
}